import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {NotificationsHttpService} from '../../../../services/http-services/notifications/notifications-http.service';
import {GrPagination} from '../../../../interfaces/general-interfaces';
import {Subscription} from 'rxjs';
import {WebsocketsHelperService} from '../../../../services/helpers/websockets-helper.service';
import {NotificationsModelTypeAdmin} from '../../../../enums/notification-enums';
import {NgClass, NgForOf} from '@angular/common';
import {TimeAgoPipe} from '../../../../pipes/time-ago/time-ago.pipe';
import {NotificationsHelperService} from '../../../../services/helpers/notifications-helper.service';

@Component({
  selector: 'gr-notification-users-tab',
  standalone: true,
  templateUrl: './notification-users-tab.component.html',
  imports: [
    NgForOf,
    TimeAgoPipe,
    NgClass
  ]
})
export class NotificationUsersTabComponent implements OnInit, OnDestroy {
  urlParams = {page: 1};
  notificationsPagination: GrPagination | undefined;
  notifications: any[] = [];
  notificationsCount = 0;
  wsNotificationsSubscription = new Subscription();
  isRequestFinish = false;
  @Output() usersNotificationsCount: EventEmitter<number> = new EventEmitter<number>();

  constructor(private notificationsHttpService: NotificationsHttpService,
              private notificationsHelperService: NotificationsHelperService,
              private websocketsHelperService: WebsocketsHelperService) {}

  ngOnInit(): void {
    this.notificationsPagination = undefined;
    this.notifications = [];
    this.getUsersNotifications();
    this.wsNotificationsSubscription = this.websocketsHelperService.notificationReceivedSubject.subscribe((res: any) => {
      if (res.type === NotificationsModelTypeAdmin.userCreated) {
        this.usersNotificationsCount.emit(this.notificationsCount + 1);
        this.notifications.unshift({
          ...res,
          read_at: null,
          data: {data: res.data, id: res.data.id, created_at: res.created_at}
        });
      }
    });
  }

  ngOnDestroy(): void {
    this.wsNotificationsSubscription.unsubscribe();
  }

  getUsersNotifications(): void {
    this.urlParams.page = this.notificationsPagination?.currentPage ? this.notificationsPagination.currentPage + 1 : 1;
    this.notificationsHttpService.getUsersNotifications(this.urlParams).then((res: any) => {
      this.notifications = [...this.notifications, ...res.data];
      this.notificationsPagination = res.pagination;
      this.notificationsCount = res.unreadCount;
      this.usersNotificationsCount.emit(this.notificationsCount);
      this.isRequestFinish = true;
    });
  }

  clickOnNotification(notification: any): void {
    if (notification.read_at === null) {
      this.usersNotificationsCount.emit(--this.notificationsCount);
      this.notificationsHelperService.clickOnUnreadNotification();
      if (this.checkIfDescriptionContainsBusiness(notification)) {
        this.notificationsHelperService.clickOnBusinessUnreadNotification();
        this.notificationsHttpService.postBusinessUsersReadNotification({notificationId: notification.id}).then(res => {});
      }
      notification.read_at = Date.now();
      this.notificationsHttpService.postUsersReadNotification({notificationId: notification.id}).then(res => {});
    }
  }

  checkIfDescriptionContainsBusiness(user: any): boolean {
    const description = user?.data?.data?.description;
    if (!description) return false;

    return description.toLowerCase().includes('business');
  }


  onScroll(event: any): void {
    const threshold = 100;
    const position = event.target.scrollTop + event.target.offsetHeight;
    const height = event.target.scrollHeight;

    if (position > height - threshold && (this.notificationsPagination?.currentPage ?? 0) < (this.notificationsPagination?.lastPage ?? 0) && this.isRequestFinish) {
      this.isRequestFinish = false;
      this.getUsersNotifications();
    }
  }
}
